import { render } from "./product-detail.vue?vue&type=template&id=cea2c4e4&scoped=true"
import script from "./product-detail.vue?vue&type=script&lang=js"
export * from "./product-detail.vue?vue&type=script&lang=js"

import "./product-detail.vue?vue&type=style&index=0&id=cea2c4e4&lang=css"
import "./product-detail.vue?vue&type=style&index=1&id=cea2c4e4&scoped=true&lang=css"
import "./product-detail.vue?vue&type=style&index=2&id=cea2c4e4&scoped=true&lang=css"
import "./product-detail.vue?vue&type=style&index=3&id=cea2c4e4&lang=css"

import exportComponent from "/Users/suniyl/Documents/work/shopify-projects/behno/behno-us-version-3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cea2c4e4"]])

export default __exports__